var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
    fill: "#5BA1E8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.62469 26.0327L7 25.2519H7L7.62469 26.0327ZM10.2313 23.9474L9.60665 23.1665L10.2313 23.9474ZM10.2542 23.8772L10.4021 22.8882L10.2542 23.8772ZM6.01063 19.2611L7.00853 19.1963L6.01063 19.2611ZM7 15.3324C7 13.1233 8.79086 11.3324 11 11.3324V9.3324C7.68629 9.3324 5 12.0187 5 15.3324H7ZM7 18.9324V15.3324H5V18.9324H7ZM7.00853 19.1963C7.00288 19.1092 7 19.0212 7 18.9324H5C5 19.0644 5.00428 19.1956 5.01273 19.3258L7.00853 19.1963ZM7 25.2519V19.2654H5V25.2519H7ZM7 25.2519H7H5C5 26.9289 6.93986 27.8612 8.24939 26.8136L7 25.2519ZM9.60665 23.1665L7 25.2519L8.24939 26.8136L10.856 24.7283L9.60665 23.1665ZM11 22.9324C10.7962 22.9324 10.5966 22.9172 10.4021 22.8882L10.1063 24.8662C10.3984 24.9098 10.6969 24.9324 11 24.9324V22.9324ZM18 22.9324H11V24.9324H18V22.9324ZM22 18.9324C22 21.1415 20.2091 22.9324 18 22.9324V24.9324C21.3137 24.9324 24 22.2461 24 18.9324H22ZM22 15.3324V18.9324H24V15.3324H22ZM18 11.3324C20.2091 11.3324 22 13.1233 22 15.3324H24C24 12.0187 21.3137 9.3324 18 9.3324V11.3324ZM11 11.3324H18V9.3324H11V11.3324ZM10.856 24.7283C11.3168 24.3597 11.3708 23.6787 10.9739 23.2421L9.49399 24.5875C9.11451 24.17 9.16613 23.5189 9.60665 23.1665L10.856 24.7283ZM6.74524 18.5906C6.12866 17.9124 5 18.3483 5 19.2654H7C7 20.1768 5.87822 20.6101 5.26538 19.936L6.74524 18.5906ZM10.9739 23.2421C11.6023 23.9333 11.0004 24.9999 10.1063 24.8662L10.4021 22.8882C9.46593 22.7481 8.83702 23.8648 9.49399 24.5875L10.9739 23.2421ZM5.01273 19.3258C4.95177 18.3864 6.10949 17.8913 6.74524 18.5906L5.26538 19.936C5.90503 20.6396 7.06986 20.1415 7.00853 19.1963L5.01273 19.3258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.293,
    cy: 17.1747,
    r: 1.0625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.543,
    cy: 17.1747,
    r: 1.0625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.793,
    cy: 17.1747,
    r: 1.0625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 7.50024H19C22.866 7.50024 26 10.6343 26 14.5002V19.5002",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu4);
export default __webpack_public_path__ + "static/media/menu4.f55249d73070c887a9c96346e05726dd.svg";
export { ForwardRef as ReactComponent };